var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmileyMeh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 49.9221C40.3051 49.9221 49.875 40.3521 49.875 28.5471C49.875 16.742 40.3051 7.17206 28.5 7.17206C16.6949 7.17206 7.125 16.742 7.125 28.5471C7.125 40.3521 16.6949 49.9221 28.5 49.9221Z",
    stroke: "#D28F3B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 35.6721H37.4062",
    stroke: "#D28F3B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4844 26.7658C21.96 26.7658 23.1562 25.5696 23.1562 24.0939C23.1562 22.6183 21.96 21.4221 20.4844 21.4221C19.0087 21.4221 17.8125 22.6183 17.8125 24.0939C17.8125 25.5696 19.0087 26.7658 20.4844 26.7658Z",
    fill: "#D28F3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5156 26.7658C37.9913 26.7658 39.1875 25.5696 39.1875 24.0939C39.1875 22.6183 37.9913 21.4221 36.5156 21.4221C35.04 21.4221 33.8438 22.6183 33.8438 24.0939C33.8438 25.5696 35.04 26.7658 36.5156 26.7658Z",
    fill: "#D28F3B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyMeh);
export default __webpack_public_path__ + "static/media/SmileyMeh.43aed5055bd0efacac20fc6f00bed296.svg";
export { ForwardRef as ReactComponent };